import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { openCustomDialog } from '../../../redux/slices/customDialogSlice';
import FormCreate from '../../../app/form/form/FormCreate';
import UserRole from '../../../common/enums/roles';

const EditFormAction = ({ payload: { form, role }, onComplete }) => {
    const dispatch = useDispatch();
    useEffect(() => {
        const onClose = onComplete ? () => onComplete(null) : undefined;
        dispatch(
            openCustomDialog(<FormCreate form={form} role={role || UserRole.ADMIN} onSubmit={onComplete} onCancel={onClose} />, { 
                beforeClose: onClose,
            })
        );
        // eslint-disable-next-line
    }, []);
};

export default EditFormAction;
